import { useSelector, useDispatch } from "react-redux";

import {
  setShowReferringProviderModal,
  setSelectedReferringProvider,
} from "app/store/referringProvider/slice/referringProviderSlice";

const useReferringProviderModal = () => {
  const {
    showReferringProviderModal,
    isUpdateOperation,
    selectedReferringProvider,
  } = useSelector((state) => state.referringProvider);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(setShowReferringProviderModal(false));
    selectedReferringProvider && dispatch(setSelectedReferringProvider(null));
  };

  return { showReferringProviderModal, isUpdateOperation, handleModalClose };
};

export default useReferringProviderModal;
